export default {
  label: {
    original: 'Original: ',
    originalNotFound: 'No encontrado',
    reloadButtonText: 'Recargar',
    errorMessage: 'Error al cargar datos',
  },
};
